import { copyRichTextToClipboard } from '@openx/utils/lib/copyToClipboard.ts';
import type { Components } from 'react-markdown';
import type { TroubleshootingMessage } from '../components/FeedbackMessageActions/FeedbackMessageActions.tsx';
import { getTroubleshootingClipboardContent } from './getTroubleshootingClipboardContent.ts';

export const copyTroubleshootingMessage = async (message: TroubleshootingMessage, components: Components = {}) => {
  const clipboardContent = await getTroubleshootingClipboardContent(message, components);

  await copyRichTextToClipboard(clipboardContent);
};
